import { keyframes, styled } from "src/styles/theme";
import * as RadixAlertDialog from "@radix-ui/react-alert-dialog";
import { Button } from "./button";

const overlayShow = keyframes({
  "0%": { opacity: 0 },
  "100%": { opacity: 1 },
});

const contentShow = keyframes({
  "0%": { opacity: 0, transform: "translate(-50%, calc(-50% + 8px)) scale(1)" },
  "100%": { opacity: 1, transform: "translate(-50%, -50%) scale(1)" },
});

const Overlay = styled(RadixAlertDialog.Overlay, {
  position: "fixed",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: 10,
  background: "$backdrop",
  animation: `${overlayShow} $transitions$duration1 cubic-bezier(0.16, 1, 0.3, 1)`,
});

const Content = styled(RadixAlertDialog.Content, {
  width: "90vw",
  maxWidth: "500px",
  maxHeight: "75vh",
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "$2",
  boxShadow: "$5",
  backgroundColor: "$background",
  zIndex: 11,
  animation: `${contentShow} $transitions$duration1 cubic-bezier(0.16, 1, 0.3, 1)`,
  padding: "$6",
});

const Title = styled(RadixAlertDialog.Title, {
  margin: 0,
  color: "$neutralTextContrast",
  fontSize: "$lg",
  fontWeight: "$medium",
});

const Description = styled(RadixAlertDialog.Description, {
  margin: "$3 0 0",
  color: "$neutralText",
  fontSize: "$base",
  lineHeight: 1.5,
});

const Actions = styled("div", {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: "$2",
  marginTop: "$6",
});

const Cancel = styled(RadixAlertDialog.Cancel, Button);
Cancel.defaultProps = {
  look: "secondary",
  color: "primary",
  size: "normal",
};

const Action = styled(RadixAlertDialog.Action, Button);
Action.defaultProps = {
  look: "primary",
  color: "primary",
  size: "normal",
};

export const AlertDialog = {
  ...RadixAlertDialog,
  Overlay,
  Content,
  Title,
  Description,
  Actions,
  Cancel,
  Action,
};
